/* eslint-disable */
export enum IncomeExpenseCategory {
    Food = "Food",
    ToolsAndMaterials = "Tools & Materials",
    Office = "Office",
    Clothing = "Clothing",
    Travel = "Travel",
    Motor = "Motor",
    Utilities = "Utilities",
    Phone = "Phone",
    Financial = "Financial",
    Rent = "Rent",
    Hotels = "Hotels",
    Training = "Training",
    ProfessionalServices = "Professional Services",
    Interest = "Interest",
    Marketing = "Marketing",
    RepairsAndMaintenance = "Repairs & Maintenance",
    Staff = "Staff",
    Other = "Other",
    CouncilTax = "Council Tax",
    Insurance = "Insurance",
    WaterCharges = "Water Charges",
    GasAndElectricalSafety = "Gas & Electrical Safety",
    ManagementAndAdvertisingFees = "Management & Advertising Fees",
    Legal = "Legal",
    PropertyVisit = "Property Visit",
    NoCategory = "No Category",
}

